'use client';

import { Pagination, type PaginationProps } from '@mui/material';
import { Center } from '@ocodelib/mui';
import clsx from 'clsx';

interface Props {
  className?: string;
  sx?: PaginationProps['sx'];

  /**
   * 사용자가 페이지 번호를 클릭했을 떄 호출됨
   * 첫번째 페이지 번호는 0
   */
  onChange?: (pageNumber: number) => void;

  /**
   * 페이지 번호, 첫번째 페이지인 경우 0
   */
  page: number;
  count: number;
  disabled?: boolean;
  hidden?: boolean;
  disableAutoScroll?: boolean;
}

/**
 * 게시판 페이지네이션
 * 주의) 서버의 페이지 번호는 0부터 시작하고
 * Mui의 페이지 번호는 1부터 시작한다.
 * 그래서 +1, -1 해준다.
 */
export function BbsPagination(props: Props) {
  const {
    onChange,
    sx,
    className,
    page,
    count,
    disabled = false,
    hidden = false,
    disableAutoScroll = false,
  } = props;

  // 페이지 버튼 클릭
  const handleClickPageNumber = (_: React.ChangeEvent<unknown>, pageNumber: number) => {
    onChange?.(pageNumber - 1);
    if (!disableAutoScroll) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  };

  if (hidden) return null;

  // 전체 페이지가 1개인 경우에는 숨김
  if (page === 0 && count <= 1) {
    return null;
  }

  // mui에서 페이지 번호는 1부터 시작해야 한다
  return (
    <Center
      className={clsx(className, 'BbsPagination-root')}
      sx={[
        {
          py: 1.5,
        },
        ...(Array.isArray(sx) ? sx : [sx ?? false]),
      ]}
    >
      <Pagination
        page={page + 1}
        count={count}
        disabled={disabled}
        onChange={onChange ? handleClickPageNumber : undefined}
      />
    </Center>
  );
}
